<form [formGroup]="addMessageFormGroup">
    <div class="d-flex gap-5 align-items-end">
        <app-button *ngIf="compact" class="flex-grow-0 flex-shrink-0" iconName="arrows-maximize" tooltip="Version complète" (clickEvent)="compact = false"></app-button>
        <app-button *ngIf="! compact" class="flex-grow-0 flex-shrink-0" iconName="arrows-minimize" tooltip="Version complète" (clickEvent)="compact = true"></app-button>
        <div class="flex-shrink-1 flex-grow-1">
            <div class="d-block" style="width: 100%;">
                <div class="d-flex gap-5" *ngIf="uploadedFiles.length > 0">
                    <app-summary-field iconName="paperclip" *ngFor="let attachment of uploadedFiles" [value]="attachment.name">
                        <app-button buttons iconName="X" (clickEvent)="removeUploadedFile(attachment)"></app-button>
                    </app-summary-field>
                </div>
                <app-input-textarea *ngIf="compact" class="flex-shrink-1 flex-grow-1"
                                    [parentFormGroup]="addMessageFormGroup"
                                    parentFormControlName="text"
                                    rows="3"
                                    (keyPressedEvent)="onKeyPressed($event)"
                                    formControlName="text">
                </app-input-textarea>
                <app-rich-text-editor *ngIf="!compact" class="flex-grow-1 flex-shrink-1"
                                      parentFormControlName="text"
                                      [parentFormGroup]="addMessageFormGroup"
                                      (contentChangeEvent)="onContentChanged()"></app-rich-text-editor>
            </div>

        </div>
        <app-button iconName="paperclip" tooltip="Joindre un fichier" (clickEvent)="addAttachments()"></app-button>
        <app-button (clickEvent)="addMessage()" [loading]="addMessageLoading" tooltip="Répondre"
                    [disabled]="addMessageFormGroup.invalid" iconName="send"></app-button>
    </div>
</form>
